import { LeaveCalendarSkeleton, LeaveSkeleton } from "../../utils/skeleton";
import LeaveCalendar from "../../components/LeaveCalendar";
import AttachIcon from "../../assets/icons/attach_file.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import NothingIcon from "../../assets/images/task-not-found-1 6.png";
import "./ApplyLeave.css";
import CustomTooltip from "../../commonComponents/CustomToolTip";
import { attendanceActions } from "../../store/AttendanceSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

const ApplyLeave = ({
  leaveDataResponseStatus,
  leaveDataResponse,
  leaveTypeSelected,
  setLeaveTypeSelected,
  minDate,
  maxDate,
  handleDateSelect,
  leaveFormData,
  reason,
  setReason,
  onSubmitLeave,
  onFileChange,
  onStartChange,
  getLeaveIcon,
  isLeaveSubmitInvalid,
  errorText,
  submitLeaveResponseStatus,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      leaveTypeSelected?.leave_type === "Maternity" ||
      leaveTypeSelected?.leave_type === "Paternity" ||
      leaveTypeSelected?.leave_type === "Miscarriage"
    ) {
      setDisableHalfMode(true);
      dispatch(attendanceActions.resetLeaveCount());
    } else {
      setDisableHalfMode(false);
    }
  }, [leaveTypeSelected, dispatch]);

  const [disableHalfMode, setDisableHalfMode] = useState(false);
  return (
    <div className="leave-modal">
      <div className="align-center flex flex-row justify-between w-full">
        <div className="leave-md-header">type</div>
        <button
          type="button"
          className="leave-mobile-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span className="material-symbols-rounded">close</span>
        </button>
      </div>
      <div className="leave-type-grid">
        {leaveDataResponseStatus === "PENDING" && <LeaveSkeleton />}
        {leaveDataResponse?.body?.map((item, index) => (
          <CustomTooltip
            content={
              <div className="flex flex-col lt-content-wrap">
                <div className="lt-wrap">
                  <div className="lt-label">Allotment</div>
                  <div className="lt-value">{item?.total_days}</div>
                </div>
                <div className="lt-wrap">
                  <div className="lt-label">Last Year Credit</div>
                  <div className="lt-value">{item?.last_year}</div>
                </div>
                {/* <div className="lt-wrap">
                  <div className="lt-label">Used</div>
                  <div className="lt-value">
                    {item?.total_days - item?.balance_leave}
                  </div>
                </div> */}
              </div>
            }
            position="bottom"
            backgroundColor="#FFF"
          >
            <div
              key={index}
              className={`leave-type-box ${
                leaveTypeSelected?.leave_type === item.leave_type
                  ? "active"
                  : ""
              } ${item.balance_leave <= 0 && item?.leave_type !== "ESIC" ? "disabled" : ""}`}
              onClick={() => {
                if (item.balance_leave > 0 || item?.leave_type === "ESIC") {
                  setLeaveTypeSelected(item);
                  dispatch(attendanceActions.resetLeaveCount());
                  if (
                    item?.leave_type === "Maternity" ||
                    item?.leave_type === "Paternity" ||
                    item?.leave_type === "Miscarriage"
                  ) {
                    dispatch(attendanceActions.setHalfMode(false));
                  }
                }
              }}
            >
              <div className="flex items-center gap-2">
                <img
                  className="leave-type-img"
                  src={getLeaveIcon(item?.leave_type)}
                  alt={item.description}
                />
                {/* <div className="leave-type-name">{item.description}</div> */}
                <div className="leave-type-name">
                  {item.description?.replace(/\bleave\b/gi, "").trim()}
                </div>
              </div>
              <div
                className={`leave-type-wrap ${item.balance_leave <= 0 && item?.leave_type !== "ESIC" ? "disabled" : ""}`}
              >
                <div className="leave-type-desc">
                  {Math.floor(item.balance_leave * 2) / 2 || 0}
                </div>
              </div>
            </div>
          </CustomTooltip>
        ))}
      </div>
      {!leaveDataResponse?.body?.length &&
        leaveDataResponseStatus !== "PENDING" && (
          <div className="flex flex-col items-center justify-center h-full w-full">
            <img className="rp-empty-ico" src={NothingIcon} alt="" />
            <div className="rp-empty-text">No Leaves available</div>
          </div>
        )}
      {leaveDataResponseStatus === "PENDING" && <LeaveCalendarSkeleton />}
      {leaveDataResponseStatus === "SUCCESS" && (
        <LeaveCalendar
          minDate={minDate}
          maxDate={maxDate}
          onDateSelect={handleDateSelect}
          leaveFormData={leaveFormData}
          disableHalfMode={disableHalfMode}
          onStartChange={onStartChange}
        />
      )}
      {isLeaveSubmitInvalid && (
        <div className="error-wrapper">
          <span
            className="material-symbols-rounded"
            style={{ fontSize: "16px", color: "red" }}
          >
            info
          </span>
          <div className="half-error-message">{errorText}</div>
        </div>
      )}
      <div className="leave-extra-box">
        <div className="work-dropdown">
          <input
            type="text"
            placeholder="Enter reason for leave"
            onChange={(e) => setReason(e.target.value)}
            value={reason}
          />
        </div>
        {leaveFormData?.file ? (
          <div className="flex items-center lv-attach-file">
            <div className="lv-attach-file-text">
              {leaveFormData?.file?.name}
            </div>
            <img
              src={DeleteIcon}
              className="reg-delete-ico"
              alt=""
              onClick={() => {
                onFileChange();
              }}
            />
          </div>
        ) : (
          <div className="attachment-btn">
            <input
              type="file"
              className="lv-attach-input"
              onChange={(e) => onFileChange(e.target.files[0])}
            />
            <img className="" alt="" src={AttachIcon} />
          </div>
        )}
      </div>
      <div className="flex items-center justify-center w-full apply-leave-btn-wrap">
        <button
          className="popup-apply-btn"
          disabled={
            !leaveDataResponse?.body?.length ||
            submitLeaveResponseStatus === "PENDING"
          }
          onClick={onSubmitLeave}
        >
          <div className="pop-apply-btn-text">
            {submitLeaveResponseStatus === "PENDING"
              ? "Applying..."
              : "Apply Leave"}
          </div>
        </button>
      </div>
    </div>
  );
};
export default ApplyLeave;
